import React from 'react';
import Header from '../features/Navigation/Header';
import Footer from '../features/Footer/Footer';

/**
 * Main layout wrapper component
 * Wraps all pages with Header and Footer, eliminates repetition
 *
 * @param {Object} props
 * @param {ReactNode} props.children - Page content
 */
export const MainLayout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 pt-[88px]">
        {children}
      </main>
      <Footer />
    </div>
  );
};
